<template>
  <div id="demographics-tab-container" element-loading-background="#F7F8FC" v-loading="loading">
    <div v-for="nugget in filteredDemographics" :key="nugget.title">
      <el-card shadow="hover" class="nugget-card">

        <span class="delete" style="float: right; cursor: pointer" v-if="canDelete(nugget.field)">
          <el-tooltip
            class="item"
            effect="dark"
            content="Remove from profile"
            placement="right-end"
            >
          <i class="el-icon-delete" @click="!isProfileEditModeOn ? handleShowAlert()
              : removeNugget(nugget)"></i>
          </el-tooltip>
        </span>

        <span class="edit" style="float: right; cursor: pointer; margin-right: 10px;">
          <el-tooltip
            class="item"
            effect="dark"
            content="Edit"
            placement="left-start"
          >
            <i class="el-icon-edit" @click="!isProfileEditModeOn ? handleShowAlert()
              : editNugget(nugget)"></i>
          </el-tooltip>
        </span>

        <span class="nugget-title">{{ nugget.title }}</span>
        <div v-if="nugget.field === 'birth_date'">
          <span class="nugget-value">{{ nugget.label.split(" ")[0] }}</span>
        </div>
        <div v-else>
          <span class="nugget-value">{{ nugget.label }}</span>
        </div>
      </el-card>
    </div>

    <el-dialog
      v-if="showEditNuggetDialog"
      id="edit-nugget-dialog"
      top="30vh"
      width="60rem"
      :title="`Edit ${selectedNugget.title}`"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :visible.sync="showEditNuggetDialog"
      :destroy-on-close="true"
      :append-to-body="true"
    >
      <edit-nugget-dialog
        v-if="showEditNuggetDialog"
        :nugget="selectedNugget"
        :visible="showEditNuggetDialog"
        @close="showEditNuggetDialog = false"
        @saveNugget="saveNugget"
      />
    </el-dialog>

  </div>
</template>

<script>
import EditNuggetDialog from '@/components/permission/profile/dialogs/EditNuggetDialog';

export default {
  name: 'DemographicsTab',
  data: () => ({
    showEditNuggetDialog: false,
    selectedNugget: {},
  }),
  components: {
    EditNuggetDialog,
  },
  computed: {
    filteredDemographics() {
      return this.demographics;
    },
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    demographics: {
      type: Array,
      default: () => [],
    },
    isProfileEditModeOn: {
      type: Boolean,
      default: false,
    },
    isProfileLocked: {
      type: Boolean,
      default: false,
    },
    handleShowAlert: {
      type: Function,
      required: true,
    },
  },
  methods: {
    handleCloseDialog() {
      this.showEditNuggetDialog = false;
      this.selectedNugget = null;
    },
    editNugget(nugget) {
      this.selectedNugget = nugget;
      this.showEditNuggetDialog = true;
    },
    saveNugget(nugget) {
      this.$emit('edit-nugget', nugget);
      this.showEditNuggetDialog = false;
    },
    removeNugget(nugget) {
      this.$emit('remove-nugget', nugget);
    },
    parsedDemoValue(nugget) {
      const additionalParsing = {
        'Birth date': () => nugget.label.match(/[\d]{4}-[\d]{2}-[\d]{2}/)[0],
      };
      return additionalParsing[nugget.title]() || nugget.label;
    },
    canDelete(field) {
      const identifiers = ['id_number', 'mobile_number', 'name',
        'facebook_profile', 'instagram_handle', 'twitter_handle', 'email_address'];
      return !identifiers.includes(field);
    },
  },
};
</script>
<style lang="scss" scoped>
.nugget-title {
  display: block;
  font-size: 1.2em;
  font-weight: bold;
  color: #000;
  margin-bottom: 15px;
}

.nugget-value {
  display: block;
  font-weight: light;
}

.nugget-card {
  min-height: 100px;
  background-color: #fff;
  padding-bottom: 5px;
  margin-bottom: 15px;
  border: 0.5px solid #f0f0f0;

  .delete {
    font-size: 1.2em;
    display: none;
  }

  :hover {
    .delete {
      display: block;
    }
  }

  .edit {
    font-size: 1.2em;
    display: none;
  }

  :hover {
    .edit {
      display: block;
    }
  }
}

#demographics-tab-container {
  overflow-y: scroll;
  height: 430px;
  padding: 0 8px;
}

#edit-nugget {
  float: right;
  cursor: pointer;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// DemographicsTab.vue?60b883d8